if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.countriesThatApplyFeeForHSF = ["US", "CA", "MX", "AU", "NZ"];
			this.shouldValidateHSF = !this.countriesThatApplyFeeForHSF.includes(Shopify.country);  // HSF products should not be considered for installment fee for EUR countries
			this.ajaxifyCartItems();
			this.initializeSubscriptionDetails();
		}

		initializeSubscriptionDetails() {
			const variants = document.querySelectorAll('[class*="delivery-billing-details-"]');
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id;
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			variants.forEach((item) => {
				const className = item.className;
				const variantId = className.substring(className.lastIndexOf('-') + 1);
				console.log('Extracted ID:', variantId);
				if (variantId) {
					fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
					})
					.then((response) => response.json()).then((sellingPlanInfo) => {
						const { sellingPlan: { billingPolicy, deliveryPolicy, originalIntervalCount, sellingPlanType } = {}, error } = sellingPlanInfo;
						const isInstallment = sellingPlanType === "installment";
						if (error) {
							throw new Error("Error fetching selling plan info");
						}
						const deliveryInterval = deliveryPolicy.interval;
						const deliveryIntervalCount = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
						const billingInterval = billingPolicy.interval;
						const billingIntervalCount = billingPolicy.intervalCount;
						const spanElementCart = document.querySelector(`.delivery-billing-details-${variantId}`);
						const localizedCartSubscriptionDetailsString = KROWN.settings.locales.delivery_billing_details;
						const updatedCartString = localizedCartSubscriptionDetailsString
							.replace('{{ deliveryInterval }}', mappedIntervalToLocale[deliveryInterval.toLowerCase()])
							.replace('{{ deliveryIntervalCount }}', deliveryIntervalCount)
							.replace('{{ billingInterval }}', mappedIntervalToLocale[billingInterval.toLowerCase()])
							.replace('{{ billingIntervalCount }}', billingIntervalCount);
						if (spanElementCart) {
							spanElementCart.innerHTML = updatedCartString;
						}
					}).catch((e) => {
						console.log(e);
					});
				}
			});
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			let initialproductQuantity = 0;
			let childProduct;
			let parentProduct;
			

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if (remove) {
					remove.dataset.href = remove.getAttribute("href");
					remove.setAttribute("href", "");
					remove.addEventListener("click", (e) => {
					  e.preventDefault();
					  let showHSFModal = remove.getAttribute("data-showhsfModal");
					  let showPartnerModal = remove.getAttribute("data-showpartnerModal");
					  childProduct = remove.getAttribute("data-childproductinfo");
					  parentProduct = remove.getAttribute("data-parentproductinfo");
					  if (showHSFModal == "true") {
						  document.getElementById("hsfModal").show();
					  } else if (showPartnerModal == "true") {
						  // Store partner fee data for modal handler
						  this.partnerFeeVariantId = remove.getAttribute("data-partner-fee-variant-id");
						  this.welcomePackVariantIds = remove.getAttribute("data-welcome-pack-variant-ids");
						  this.starterBundleVariantIds = remove.getAttribute("data-starter-bundle-variant-ids");
						  this.partnerWelcomePackInCart = remove.getAttribute("data-partner-welcome-pack-in-cart") === "true";
						  this.partnerStarterBundlesInCart = remove.getAttribute("data-partner-starter-bundles-in-cart") === "true";
						  this.partnerFeeItem = item;
						  
						  // Build dynamic modal message using translations
						  let modalMessage = KROWN?.settings?.locales?.partner_application_form?.modal_remove_fee || "Are you sure you want to remove the partner application fee?";
						  if (this.partnerWelcomePackInCart && this.partnerStarterBundlesInCart) {
							modalMessage += " " + (KROWN?.settings?.locales?.partner_application_form?.modal_both_removed || "Your Welcome Pack(s) and Starter Bundle product(s) will also be removed!");
						  } else if (this.partnerWelcomePackInCart) {
							modalMessage += " " + (KROWN?.settings?.locales?.partner_application_form?.modal_welcome_pack_removed || "Your Welcome Pack(s) will also be removed!");
						  } else if (this.partnerStarterBundlesInCart) {
							modalMessage += " " + (KROWN?.settings?.locales?.partner_application_form?.modal_starter_bundles_removed || "Your Starter Bundle product(s) will also be removed!");
						  }
						  
						  document.getElementById("partner-modal-message").textContent = modalMessage;
						  document.getElementById("partnerModal").show();
					  } else {
						this.updateCartQty(item, 0)
					  }
					});
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('click', (e)=>{
						e.target.select();
						initialproductQuantity = e.target.value;
					})

					qty.addEventListener('input', debounce( async (e) =>{
						e.preventDefault();
						e.target.blur();
						const prekitAvailable = await e.target.closest("cart-product-quantity").checkProductInventoryPrekit();
						if (prekitAvailable) {
							this.updateCartQty(item, parseInt(qty.value));
						} else {
							e.target.value = initialproductQuantity;
						}	
					}, 500)
					);
				}

			});
			setTimeout(()=>{
				updateNoteObj();
			}, 100);
			
			document.querySelector("#hsfModal .remove").addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();
				let updates = {};
		
				document.querySelectorAll("[data-js-cart-item]").forEach((item) => {
				  if (childProduct == item.id) {
					let childAssociatedParent = item.querySelector('.remove').dataset.parentproductinfo;
					if (childAssociatedParent == parentProduct) {
					  updates["" + item.dataset.id] = 0; 
					}
				  }
				  if (parentProduct == item.id) {
					let parentAssociatedChild = item.querySelector('.remove').dataset.childproductinfo;
					if (parentAssociatedChild == childProduct) {
					  updates["" +item.dataset.id] = 0; 
					}
				  }
				});
				this.removeHSFLineItems(updates)
			});

			// Partner Fee Removal Handler
			const partnerModalConfirmBtn = document.querySelector("#partnerModal .partner-remove-confirm");
			if (partnerModalConfirmBtn) {
				partnerModalConfirmBtn.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();
					let updates = {};
					
					// Get cart data to find items by variant ID
					fetch('/cart.js')
						.then(response => response.json())
						.then(cartData => {
							// Add partner fee to updates
							if (this.partnerFeeItem && this.partnerFeeItem.dataset.id) {
								updates[this.partnerFeeItem.dataset.id] = 0;
							}
							
							// Get partner fee variant ID for property verification
							const partnerFeeVariantId = this.partnerFeeVariantId;
							
							// Find and add welcome packs if exist AND have _partner_fee_bundle property
							if (this.welcomePackVariantIds && this.partnerWelcomePackInCart && partnerFeeVariantId) {
								const welcomePackIds = this.welcomePackVariantIds.split(',').map(id => id.trim());
								cartData.items.forEach(cartItem => {
									if (welcomePackIds.includes(cartItem.variant_id.toString())) {
										// Verify the item has _partner_fee_bundle property linking to this partner fee
										if (cartItem.properties && 
											cartItem.properties._partner_fee_bundle && 
											cartItem.properties._partner_fee_bundle.toString() === partnerFeeVariantId.toString()) {
											updates[cartItem.key] = 0;
										}
									}
								});
							}
							
							// Find and add starter bundle products if exist AND have _partner_fee_bundle property
							if (this.starterBundleVariantIds && this.partnerStarterBundlesInCart && partnerFeeVariantId) {
								const bundleVariantIds = this.starterBundleVariantIds.split(',').map(id => id.trim());
								cartData.items.forEach(cartItem => {
									if (bundleVariantIds.includes(cartItem.variant_id.toString())) {
										// Verify the item has _partner_fee_bundle property linking to this partner fee
										if (cartItem.properties && 
											cartItem.properties._partner_fee_bundle && 
											cartItem.properties._partner_fee_bundle.toString() === partnerFeeVariantId.toString()) {
											updates[cartItem.key] = 0;
										}
									}
								});
							}
							
							// Remove all related items
							this.removePartnerRelatedItems(updates);
						})
						.catch(error => {
							console.error('Error fetching cart data:', error);
						});
				});
			}

		}

		checkAndRemoveHsfAttributes() {
			return fetch(KROWN.settings.routes.cart_url,{
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
			}).then(async (res) => await res.json()).then(cartData => {
				// Verify if attribute contains hsfChildDetails
				if(!cartData.attributes?.hsfChildDetails) {
					return
				}
		
				const items = cartData.items
		
				const hasHsfChild = items.find(item => !!item.properties?._hsf && !!item.properties._adultProductIds)
		
				if(hasHsfChild) {
					return
				}
		
				const body = {
					attributes: {
						hsfChildDetails: null
					}
				}

				return fetch(KROWN.settings.routes.cart_update_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/javascript",
					},
					body: JSON.stringify(body),
				})
			})
		}

		async checkAndRemoveHandlingFee(cartItems) {
			// Get all handling fee items
			const handlingFeeItems = cartItems.filter(item => 
				item.properties && item.properties._handling_fee
			);

			if (handlingFeeItems.length === 0) return;

			// Check each handling fee item
			for (const handlingFeeItem of handlingFeeItems) {
				const adultProductIds = handlingFeeItem.properties._adultProductIds?.split(',') || [];
				const childProductIds = handlingFeeItem.properties._childProductIds?.split(',') || [];
				
				// Check if referenced adult products still exist in cart
				const adultProductsInCart = adultProductIds.filter(id => 
					cartItems.some(item => item.id.toString() === id.toString())
				);
				
				// Check if referenced child products still exist in cart
				const childProductsInCart = childProductIds.filter(id => 
					cartItems.some(item => item.id.toString() === id.toString())
				);
				
				// Remove handling fee if either adult or child products are completely removed
				if (adultProductsInCart.length === 0 || childProductsInCart.length === 0) {
					const updates = {};
					updates[handlingFeeItem.key] = 0;
					
					await fetch(KROWN.settings.routes.cart_update_url, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
						body: JSON.stringify({ updates }),
					});
				}
			}
		}

		checkAndRemovePartnerAttributes(cartObject) {
			if(cartObject.items_removed && cartObject.items_removed.length > 0 && cartObject.attributes._partnerFeeProduct){
				cartObject.items_removed.forEach(item => {
					if(item.variant_id == Number(cartObject.attributes._partnerFeeProduct)){
						return this.removePartnerFeeAttributes();
					}
				})
			}
		}

		removePartnerFeeAttributes() {
			const body = {
				attributes: {
					_partnerFeeProduct: null
				}
			}
			return fetch(KROWN.settings.routes.cart_update_url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
				body: JSON.stringify(body),
			})
		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			return fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}else{
						return this.checkAndRemovePartnerAttributes(response);
					}
				}).then(() => {
					return this.checkAndRemoveHsfAttributes()
				}).then(() => {
					return fetch('/cart', {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/javascript",
						},
					})
				})
				.then(response => response.text())
				.then(async (response) => {
					// check if all installment variants are removed and if yes, remove installment fee
					const cartItems = JSON.parse(response).items;
					if(cartItems.length==0){
						$(".countries_list_modal-content").attr('data-cart-empty',"true");
					  }
					  else{
						$(".countries_list_modal-content").attr('data-cart-empty',"false");
					  }
					const installmentProductsThatApplyFee = cartItems.filter(item =>
						item.id !== Number(localStorage.getItem('installmentFeeProductId')) &&
						item.properties._subscriptionType === 'installment' &&
						(this.shouldValidateHSF ? !item.properties._hsf : true)
					);
					if (installmentProductsThatApplyFee.length === 0) {
						await removeInstallmentFee();
					}

					// Check and remove handling fee if adult or child products are removed
					await this.checkAndRemoveHandlingFee(cartItems);

					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(response => {
					const sectionInnerHTML = new DOMParser().parseFromString(response, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated', { bubbles: true });
					this.dispatchEvent(event);

					if (typeof window.refreshCartPaymentMethods === "function") {
						setTimeout(() =>{ 
							window.refreshCartPaymentMethods()
						}, 100);
					}
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

		removeHSFLineItems(updates) {
			let alert = null;
	  
			this.form.classList.add("processing");
			if (this.querySelector(".alert")) {
			  	this.querySelector(".alert").remove();
			}    
			
			const body = JSON.stringify({updates});
	  
			return fetch(KROWN.settings.routes.cart_update_url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
				body,
			})
			.then((response) => response.json())
			.then((response) => {
				if (response.status == 422) {
					// wrong stock logic alert
					alert = document.createElement("span");
					alert.classList.add("alert", "alert--error");
					if (typeof response.description === "string") {
					alert.innerHTML = response.description;
					} else {
					alert.innerHTML = response.message;
					}
				}else{
					return this.checkAndRemovePartnerAttributes(response);
				}
			}).then(() => {
				return this.checkAndRemoveHsfAttributes()
			}).then(() => {
				return fetch('/cart', {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/javascript",
					},
				})
			})
			.then(response => response.text())
			.then(async (response) => {
				// check if all installment variants are removed and if yes, remove installment fee
				const cartItems = JSON.parse(response).items;
				const installmentProductsThatApplyFee = cartItems.filter(item =>
					item.id !== Number(localStorage.getItem('installmentFeeProductId')) &&
					item.properties._subscriptionType === 'installment' &&
					(this.shouldValidateHSF ? !item.properties._hsf : true)
				);
				if (installmentProductsThatApplyFee.length === 0) {
					await removeInstallmentFee();
				}

				// Check and remove handling fee if adult or child products are removed
				await this.checkAndRemoveHandlingFee(cartItems);

				return fetch('?section_id=helper-cart');
			})
			.then((response) => response.text())
			.then((text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(
					text,
					"text/html"
				);
				const cartFormInnerHTML =
					sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
				const cartSubtotalInnerHTML =
					sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;
		
				const cartItems = document.getElementById("AjaxCartForm");
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
		
				document
					.querySelectorAll("[data-header-cart-count]")
					.forEach((elm) => {
					elm.textContent =
						cartItems.querySelector("[data-cart-count]").textContent;
					});
				document
					.querySelectorAll("[data-header-cart-total")
					.forEach((elm) => {
					elm.textContent =
						cartItems.querySelector("[data-cart-total]").textContent;
					});
		
				if (alert !== null) {
					this.form.prepend(alert);
				}
		
				document.getElementById("AjaxCartSubtotal").innerHTML =
					cartSubtotalInnerHTML;
		
				const event = new Event("cart-updated", { bubbles: true });
				this.dispatchEvent(event);

				if (typeof window.refreshCartPaymentMethods === "function") {
          			setTimeout(() => {
						window.refreshCartPaymentMethods()
					}, 100);
        		}
			})
			.catch((e) => {
				console.log(e);
				let alert = document.createElement("span");
				alert.classList.add("alert", "alert--error");
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			})
			.finally(() => {
				this.form.classList.remove("processing");
				document.querySelector("#hsfModal .modal-close").click();
			});
		}

		removePartnerRelatedItems(updates) {
			let alert = null;
	  
			this.form.classList.add("processing");
			if (this.querySelector(".alert")) {
			  	this.querySelector(".alert").remove();
			}    
			
			const body = JSON.stringify({updates});
	  
			return fetch(KROWN.settings.routes.cart_update_url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
				body,
			})
			.then((response) => response.json())
			.then((response) => {
				if (response.status == 422) {
					// wrong stock logic alert
					alert = document.createElement("span");
					alert.classList.add("alert", "alert--error");
					if (typeof response.description === "string") {
					alert.innerHTML = response.description;
					} else {
					alert.innerHTML = response.message;
					}
				}else{
					// Directly remove partner fee attribute since we know partner fee is being removed
					return this.removePartnerFeeAttributes();
				}
			}).then(() => {
				return this.checkAndRemoveHsfAttributes()
			}).then(() => {
				return fetch('/cart', {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/javascript",
					},
				})
			})
			.then(response => response.text())
			.then(async (response) => {
				// check if all installment variants are removed and if yes, remove installment fee
				const cartItems = JSON.parse(response).items;
				const installmentProductsThatApplyFee = cartItems.filter(item =>
					item.id !== Number(localStorage.getItem('installmentFeeProductId')) &&
					item.properties._subscriptionType === 'installment' &&
					(this.shouldValidateHSF ? !item.properties._hsf : true)
				);
				if (installmentProductsThatApplyFee.length === 0) {
					await removeInstallmentFee();
				}

				// Check and remove handling fee if adult or child products are removed
				await this.checkAndRemoveHandlingFee(cartItems);

				return fetch('?section_id=helper-cart');
			})
			.then((response) => response.text())
			.then((text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				if ( alert !== null ) {
					this.form.prepend(alert);
				} 

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
						
				if (document.querySelector('cart-recommendations')) {
					document.querySelector('cart-recommendations').innerHTML = '';
					document.querySelector('cart-recommendations').generateRecommendations();
				}

				const event = new Event("cart-updated", { bubbles: true });
				this.dispatchEvent(event);

				if (typeof window.refreshCartPaymentMethods === "function") {
				setTimeout(() => {
					window.refreshCartPaymentMethods();
				}, 100);
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				this.form.classList.remove("processing");
				document.getElementById("partnerModal").hide();
			});
		}

	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', async (e) => {
				const prekitResponse = await this.checkProductInventoryPrekit();
				if (prekitResponse) {
					this.changeCartInput(this);
				} else {
					const inputElement = e.target.closest("cart-product-quantity").querySelector("input");
					inputElement.value = inputElement.value - 1;
				}
			})
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}

		// function to check for prekit in mini-cart when adding product quantity
		async checkProductInventoryPrekit() {
			const miniCartComponent = this.closest(".cart-item__content");
			const cartComponent = this.closest(".cart-item__product-info");
			const currentComponent = miniCartComponent ?? cartComponent; // set current component based on cart or cart-flyout

			const url = `${currentComponent.querySelector("a").href}&view=inventory-check`;
			const userInputQuantity = currentComponent.querySelector("input").value;
			let cartForm = this.closest("#AjaxCartForm").form;
			const productName = currentComponent.querySelector(".cart-item__title").innerText;
			const productVariant = currentComponent.querySelector(".cart-item__variant")?.innerText.split(": ")[1];
			let canAddQuantity = true;
			let alertWarning = null;

			if ( cartForm.querySelector('.alert--error') ) {
				cartForm.querySelectorAll('.alert--error').forEach(alert => alert.remove());
			}

			try {

				const response = await fetch(url);

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const responseData = await response.text(); // Assuming plain text
				const prekit_data = responseData.trim().split("|"); // disabling/enabling add to cart button - not required here
				const prekitObj = JSON.parse(prekit_data[1]); // object with inventory amount and quantity of variants in prekit

				if (prekitObj.length > 0) {
					const minqty = prekitObj[0].inventory / prekitObj[0].quantity;

					for (let prekit of prekitObj) {
						const quantity = prekit["quantity"];
						const inventory = prekit["inventory"];
						if (minqty > inventory / quantity) {
							minqty = inventory / quantity;
						}
						if (quantity * userInputQuantity > parseInt(inventory)) {
							canAddQuantity = false;
							break;
						}
					}

					if (!canAddQuantity) {
						alertWarning = document.createElement('span');
						alertWarning.classList.add('alert', 'alert--error');
						const alertText = KROWN.settings.cart_prekit_error.replace("{{ product }}",`${productName} - ${productVariant}`);
						alertWarning.innerHTML = alertText;
						cartForm.prepend(alertWarning);
					}
				} else {
					canAddQuantity = true; // no prekit information, hence OOTB process for adding quantity
				}
				return canAddQuantity;
			}
			catch(error) {
				console.error("Error fetching stock data:", error); // Handle error gracefully, e.g., display an error message to the user
			};
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		return new Promise((resolve, reject) => {
			fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => {
	
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
	
				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
	
				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				})
				
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
					document.querySelector('[data-js-site-cart-sidebar]').show();
				}
	
				if ( document.querySelector('cart-recommendations') ) {
					document.querySelector('cart-recommendations').innerHTML = '';
					document.querySelector('cart-recommendations').generateRecommendations();
				}
	
				resolve()
			})
		})

	}

}
if (!window.refreshCartPaymentChange) {
  window.refreshCartPaymentChange = async () => {
    try {
      // Fetch the updated cart section
      const response = await fetch("?section_id=helper-cart");
      const text = await response.text();

      const sectionInnerHTML = new DOMParser().parseFromString(
        text,
        "text/html"
      );

      // Get updated cart form and subtotal HTML
      const cartFormInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
      const cartSubtotalInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

      // Update cart form
      const cartItems = document.getElementById("AjaxCartForm");
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      // Update cart count and total in header
      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent =
          cartItems.querySelector("[data-cart-count]").textContent;
      });

      document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
        elm.textContent =
          cartItems.querySelector("[data-cart-total]").textContent;
      });

      // Update subtotal
      document.getElementById("AjaxCartSubtotal").innerHTML =
        cartSubtotalInnerHTML;

      // Update cart recommendations
      const recommendations = document.querySelector("cart-recommendations");
      if (recommendations) {
        recommendations.innerHTML = "";
        recommendations.generateRecommendations();
      }

      // Refresh payment methods after 100ms delay
      if (typeof window.refreshCartPaymentMethods === "function") {
        console.log("🛒 hitting refreshCartPaymentMethods from component-cart");
        await new Promise((resolve) => {
          setTimeout(async () => {
			console.log("🛒 initiate refreshCartPaymentMethods from component-cart");
            await window.refreshCartPaymentMethods();
			console.log("🛒 completed refreshCartPaymentMethods from component-cart");
            resolve();
			console.log("🛒 promise resolved refreshCartPaymentMethods from component-cart");
          }, 100);
        });
      }
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  };
}

function updateNoteObj() {
	// let noteElement = document.getElementById("cartSpecialInstructions");
	// Commenting custom note object as installment details will be moved to order metafields
	// if (noteElement) {
	// 	let noteObjStr = noteElement.value;
	// 	let isLeadPool = document.getElementById("isLeadPool");
	// 	try {
	// 		let NoteObj = JSON.parse(noteObjStr);
	// 		NoteObj.isLeadPool = isLeadPool && isLeadPool.value === "true" ? true : false;
	// 		noteElement.value = JSON.stringify(NoteObj);
	// 	} catch(e) {
	// 		console.log("Error" + e);
	// 	}
	// }
	// update hsf child form details in cart attribute
}

document.addEventListener("DOMContentLoaded", function () {
  updateNoteObj();
});
